"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trekOverview = exports.profile = exports.amenities = exports.cardOverlay = exports.card = void 0;
var card = {
  trek: 'icon icon-hg-hiking',
  lodge: 'icon icon-hg-home',
  sighting: 'icon icon-hg-binoculars',
  attraction: 'icon icon-hg-attraction',
  sidetrip: 'icon icon-hg-man-in-hike',
  place: 'icon icon-hg-map-pin',
  flights: 'icon icon-hg-flight',
  guide: 'icon icon-hg-man-in-hike'
};
exports.card = card;
var cardOverlay = {
  add: 'icon icon-hg-plus',
  remove: 'icon icon-hg-trash',
  view: 'icon icon-hg-eye'
};
exports.cardOverlay = cardOverlay;
var amenities = {
  bed: 'icon icon-hg-bed',
  breakfast: 'icon icon-hg-bread',
  lunch: 'icon icon-hg-breakfast-odd',
  dinner: 'icon icon-hg-serving-lunch',
  charging: 'icon icon-hg-charger',
  hotshower: 'icon icon-hg-shower-o',
  wifi: 'icon icon-hg-wifi-signal',
  attachedtoilet: 'icon icon-hg-western-toilet',
  toiletpaper: 'icon icon-hg-toilet-paper',
  "default": 'icon icon-hg-service-default'
};
exports.amenities = amenities;
var profile = 'icon icon-hg-profile-old';
exports.profile = profile;
var trekOverview = {
  sun: 'icon icon-hg-sun-o',
  group: 'icon icon-hg-group'
};
exports.trekOverview = trekOverview;